import { FaBell, FaUserCircle } from "react-icons/fa";
import { useContext } from "react";
import { UserContext } from "../../context/UserContext";

import VisionRoyaleLogo from "../../media/VisionRoyale_logo.png";

export default function AdminTopBar() {
  const { user } = useContext(UserContext);

  return (
    <header
      className="
        h-20
        flex
        items-center
        justify-between
        px-6
        border-b
        border-green-500/20
        bg-gray-950/60
        backdrop-blur-xl
      "
    >

      {/* Logo */}
      <div className="flex items-center gap-3">

        <div className="w-24 h-24 rounded-2xl overflow-hidden transform group-hover:scale-110 transition-all duration-300">
            <img
                src={VisionRoyaleLogo}
                alt="Vision Royale"
                className="w-full h-full object-contain"
            />
        </div>

        <div className="flex flex-col justify-center leading-none ml-2">
            <div className="flex items-center gap-1">
            <h1 className="text-2xl font-extrabold bg-gradient-to-r from-emerald-400 via-green-300 to-cyan-300 bg-clip-text text-transparent">
                Vision
            </h1>
            </div>
            <h1 className="text-2xl font-extrabold bg-gradient-to-r from-emerald-400 via-green-300 to-cyan-300 bg-clip-text text-transparent -mt-1">
            Royale
            </h1>
        </div>

      </div>


      {/* Right side */}
      <div className="flex items-center gap-5">

        <button
          className="
            relative
            text-gray-400
            hover:text-green-400
            transition
          "
        >
          <FaBell size={20} />

          <span
            className="
              absolute
              -top-1
              -right-1
              w-3
              h-3
              bg-green-500
              rounded-full
            "
          />

        </button>


        <div
          className="
            flex
            items-center
            gap-3
            bg-black/30
            border
            border-green-500/20
            rounded-xl
            px-3
            py-2
          "
        >

          <FaUserCircle
            className="text-green-400"
            size={28}
          />

          <div className="hidden sm:block">

            <p className="text-white text-sm font-semibold">
              {user?.username || "Admin"}
            </p>

            <p className="text-gray-400 text-xs">
              Administrator
            </p>

          </div>

        </div>

      </div>

    </header>
  );
}